import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, ActionSheetController, ModalController, AlertController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MdaPessoaAddPage } from '../mda-pessoa-add/mda-pessoa-add.page';
import { MdaProvider } from 'src/app/services/mda/mda';
import { UserProvider } from 'src/app/services/user/user';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { ImagePipe } from 'src/app/pipes/image/image';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { LoadingSpinnerComponent } from 'src/app/components/loading/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-mda-pessoa',
  templateUrl: './mda-pessoa.page.html',
  styleUrls: ['./mda-pessoa.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    ImagePipe,
    NomenclaturaPipe,
    SemRegistroComponent,
    LoadingSpinnerComponent
  ],
})
export class MdaPessoaPage implements OnInit {
  mdas: any = { discipuladores: [], discipulos: [], proximoEncontro: {} };
  pessoa: any = {};
  modoReduzido: boolean = false;
  mdaTipo: string = 'discipulador';
  loaded: boolean = false;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public mdaProvider: MdaProvider,
    public actionSheetCtrl: ActionSheetController,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public userProvider: UserProvider,
    private translate: TranslateService
  ) {
    this.pessoa = this.navParams.get('pessoa');
    this.modoReduzido = this.navParams.get('modoReduzido');

    this.mdaProvider.getPessoaMdaById(this.pessoa.id)
      .subscribe((data) => {
        this.mdas = data;

        setTimeout(() => {
          this.loaded = true;
        }, 1000);
      });
  }

  ngOnInit() { }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async remover(id: any) {
    const alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant('Atenção'),
      message: this.translate.instant('Realmente deseja excluir esse vínculo?'),
      buttons: [
        {
          text: this.translate.instant('Não'),
          handler: () => { }
        },
        {
          text: this.translate.instant('Sim'),
          handler: () => {
            this.mdaProvider.removerVinculo(id, this.pessoa.id).subscribe((data) => {
              this.mdas.discipuladores = data.discipuladores;
              this.mdas.discipulos = data.discipulos;
            });
          }
        }
      ]
    });

    alert.present();
  }

  async addDiscipulador() {
    const data = { pessoa: this.pessoa };
    const modalDiscipulado = await this.modalCtrl.create({ component: MdaPessoaAddPage, componentProps: data });
    modalDiscipulado.present();

    const result = (await modalDiscipulado.onWillDismiss())
    if (result.data) {
      this.mdas.discipuladores = result.data.discipuladores;
      this.mdas.discipulos = result.data.discipulos;
    }
  }

  async opcoesMda(mda: { id: any; }, mdaVinculo: any) {

    let actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('Opções'),
      buttons: [
        {
          text: this.translate.instant('Editar Vinculo'),
          handler: async () => {
            const data = { pessoa: this.pessoa, mda: mda, mdaVinculo: mdaVinculo };
            const modalDiscipulado = await this.modalCtrl.create({ component: MdaPessoaAddPage, componentProps: data });
            modalDiscipulado.present();

            const result = (await modalDiscipulado.onWillDismiss())
            if (result.data) {
              this.mdas.discipuladores = result.data.discipuladores;
              this.mdas.discipulos = result.data.discipulos;
            }
          }
        },
        {
          text: this.translate.instant('Remover Vinculo'),
          handler: () => {
            this.remover(mda.id);
          }
        },
        {
          text: 'Cancelar',
          handler: () => {
            actionSheet.dismiss();
          }
        }

      ]
    });

    actionSheet.present();
  }
}
